import React from 'react'
import classNames from 'classnames'
import moment from 'moment'
import { picProcess } from 'meinian-package/src/utils/image'
import emptyImg from 'image/empty/empty_card_logo.png'
import { getJumpUrl } from './config'
import useViewed from './useViewed'

const infoEnumText = {
  system_notify: '系统消息', // 系统消息
  personal: '美念消息', // 个人消息
  system_remind: '美念消息', // 系统提醒
}

const onJump = (cur) => {
  const url = getJumpUrl(cur)
  url && window.open(url)
}

const BaseAvatar = ({ item }) => {
  return <img src={picProcess(item.params.sender?.avatar) || emptyImg} className="mn-table-td-head-portrait" />
}
const BaseUserName = ({ item }) => {
  return <div className="info-line-1-title text-overflow">{item.params.sender?.text}</div>
}

export const getRecentlyTimeText = (createdAt) => {
  const createTime = moment(createdAt)
  const diffTime = moment.duration(moment().diff(createTime))
  const { years, months, days, hours, minutes } = diffTime._data

  let timeText = ''
  if (years || months || days) {
    timeText = moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
    return timeText
  }
  if (hours) {
    timeText += `${+hours}小时`
  }
  timeText += `${+minutes || 1}分钟`
  return `${timeText}前`
}

const BaseFooter = ({ item }) => {
  const recentlyTimeText = getRecentlyTimeText(item.createdAt)

  return (
    <div className="mn-drawer-notice-content-list-item-info-wrap-footer">
      <div>{recentlyTimeText}</div>
      <div style={{ color: 'var(--m-text-4)' }}>{infoEnumText[item.msgType]}</div>
    </div>
  )
}

export const MNInfoItem = ({ item, onInit }) => {
  const { onViewed } = useViewed(item, onInit)
  return (
    <div
      className={classNames('mn-drawer-notice-content-list-item', { unread: item.viewed !== 1 })}
      onClick={async () => {
        await onViewed()
        onJump({
          jumpType: item.jumpType,
          jumpUrlParams: item.jumpUrlParams,
        })
      }}
    >
      <BaseAvatar item={item} />
      <div className="mn-drawer-notice-content-list-item-info-wrap">
        <div className="mn-drawer-notice-content-list-item-info">
          <div>
            <div className="info-line-1">
              <BaseUserName item={item} />
              <div className="info-line-1-sub-title">{item.title}</div>
            </div>
            <div className="info-line-content text-overflow">&quot;{item.content}&quot;</div>
            <div className="info-line-2 text-overflow">{item.params.inspiration?.text}</div>
          </div>
          {item.picUrl && (
            <img src={picProcess(item.picUrl) || emptyImg} className="mn-drawer-notice-content-list-item-info-img" />
          )}
        </div>
        <BaseFooter item={item} />
      </div>
    </div>
  )
}

export const SystemInfo = ({ item, onInit }) => {
  const { onViewed } = useViewed(item, onInit)
  return (
    <div
      className={classNames('mn-drawer-notice-content-list-item', { unread: item.viewed === 1 })}
      onClick={async () => {
        await onViewed()
        onJump({
          jumpType: item.jumpType,
          jumpUrlParams: item.jumpUrlParams,
        })
      }}
    >
      <BaseAvatar item={item} />
      <div className="mn-drawer-notice-content-list-item-info-wrap">
        <div className="mn-drawer-notice-content-list-item-info">
          <div>
            <div className="info-line-1">
              <BaseUserName item={item} />
              <div className="info-line-1-sub-title">申请加入团队</div>
              <div className="info-line-1-title" style={{ marginLeft: '4px' }}>
                产品
              </div>
            </div>
          </div>
        </div>
        <BaseFooter item={item} />
      </div>
    </div>
  )
}

export const BaseInfo = ({ item, onInit }) => {
  const { onViewed } = useViewed(item, onInit)
  return (
    <div
      className={classNames('mn-drawer-notice-content-list-item', { unread: item.viewed === 1 })}
      onClick={async () => {
        await onViewed()
        onJump({
          jumpType: item.jumpType,
          jumpUrlParams: item.jumpUrlParams,
        })
      }}
    >
      <BaseAvatar item={item} />
      <div className="mn-drawer-notice-content-list-item-info-wrap">
        <div className="mn-drawer-notice-content-list-item-info">
          <div>
            <div className="info-line-1">
              <div style={{ color: 'var(--m-text-1)' }}>{item.content}</div>
            </div>
          </div>
        </div>
        <BaseFooter item={item} />
      </div>
    </div>
  )
}
